import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError"

export function useGetPractSchedule({ onSuccess, practId, date, scheduleId, orgId, isGetAll = false }) {
    const url = `schedule/${(scheduleId && orgId) ? `${scheduleId}?orgId=${orgId}`: `check?actorId=${practId}&${isGetAll ? "isGetAll=true" : `date=${date}`}`}`
    const fetch = () => {
        return axios.get(url);
    };
    const query = useQuery(
        ["schedule-by-date", practId, date, isGetAll, scheduleId, orgId],
        () => fetch(),
        {
            refetchOnWindowFocus: false,
            select: (data) => data,
            onSuccess,
            onError,
            enabled: (Boolean(practId) && (isGetAll || Boolean(date))) || (Boolean(scheduleId) && Boolean(orgId)),
        }
    );

    return { ...query };
}